/**
 * OrganizacaoPage — domínio "Organização" (`/admin/organizacao`), Admin Hub T7.
 *
 * Primeira das 5 páginas de domínio (T7-T11) — estabelece o padrão de
 * migração que as demais copiam: `DomainSaveProvider` no topo, uma
 * `DomainSection` por item do catálogo com o form real como filho, a ponte
 * Pessoas → Usuários (link, não formulário) e a `StickySaveBar` agregando o
 * salvamento de todas as seções.
 *
 * `canManage` é a cap de ESCRITA (`tenant-config-manage`) e é resolvida AQUI,
 * uma vez, e passada a todo tab de `config-tenant/` que a página componha —
 * mesmo contrato que `ConfigTenantPage.tsx` já usa para os 9 tabs (medido em
 * context.md). `DomainSection` gateia LEITURA pela capability do catálogo;
 * as duas gates são ortogonais (ex.: Solo lê branding mas não escreve).
 *
 * Fidelidade — prancha "05 Dominio Organizacao.dc.html" (variante 5a), com
 * duas divergências DECLARADAS (racional completo em task-7-report.md):
 *   1. "Identidade visual" na prancha é um resumo condensado (thumbnail de
 *      logo + 2 swatches + contagem); aqui é o editor completo
 *      (`BrandingSection`, extraído de `pages/BrandingPage.tsx`) porque o
 *      dispatch da T7 pede explicitamente reuso do componente real — um
 *      resumo fabricaria contagens sem fonte (contra P17).
 *   2. A ponte "Usuários e acesso" na prancha mostra "12 operadores · 2
 *      convites pendentes" — não há fonte wireada para esse número aqui (nem
 *      no exemplo de código do próprio brief); não fabricado.
 * A busca "Buscar nesta página…" do cabeçalho da prancha não existe — é
 * parte do layout de `DomainPage` (T4), fora do escopo desta task.
 */
import { Link } from 'react-router-dom';

import { useCapability } from '../../../../hooks/use-capability';
import { BrandingSection } from '../../branding/BrandingSection';
import { GeneralTab } from '../../config-tenant/GeneralTab';
import { CONFIG_CATALOG } from '../catalog';
import { DomainPage } from '../DomainPage';
import { DomainSection } from '../DomainSection';
import { DomainSaveProvider } from '../save-bar-context';
import { StickySaveBar } from '../StickySaveBar';

function item(id: string) {
  const found = CONFIG_CATALOG.find((i) => i.id === id);
  if (found === undefined) throw new Error(`Item de catálogo ausente: ${id}`);
  return found;
}

export function OrganizacaoPage(): JSX.Element {
  const canManage = useCapability('tenant-config-manage');

  return (
    <DomainSaveProvider>
      <DomainPage dominio="organizacao">
        <DomainSection item={item('geral')}>
          <GeneralTab canManage={canManage} />
        </DomainSection>
        <DomainSection item={item('identidade-visual')}>
          <BrandingSection />
        </DomainSection>
        <section className="border-t border-border-subtle py-8">
          <h2 className="text-lg font-semibold text-text-primary">Pessoas</h2>
          <p className="mt-1 mb-3 text-sm text-text-secondary">
            Convites, papéis e hierarquia vivem na gestão de usuários.
          </p>
          <Link to="/admin/users" className="text-sm font-medium text-accent hover:underline">
            Abrir Usuários →
          </Link>
        </section>
        <StickySaveBar />
      </DomainPage>
    </DomainSaveProvider>
  );
}
